import { BlogSection } from '@/types/blog';

export const aktivesManagement: BlogSection = {
  id: 'aktives-management',
  title: 'Risse im Monolith: Wo aktives Management fruchtbaren Boden findet',
  content: `
    <p>Trotz der erdrückenden Langfrist-Statistiken ist die Geschichte nicht zu Ende. Ein genauerer Blick auf die Daten offenbart Risse in der monolithischen Fassade der passiven Überlegenheit.</p>

    <h3>Small Caps: Die große Ausnahme</h3>

    <p>In den USA konnten 2024 erstaunliche <strong>70% der aktiv verwalteten Small-Cap-Fonds</strong> den S&P SmallCap 600 Index übertreffen. Das beste Ergebnis seit über zwei Jahrzehnten. In Europa zeigte sich dasselbe Muster: <strong>Eurozone Small-Cap aktive Fonds erreichten eine Erfolgsquote von 35,9% über 10 Jahre</strong>. Deutlich über der Large-Cap-Quote von nur 5,3%.</p>

    <h3>Anleihen: Wo Können zählt</h3>

    <p>2024 war ein starkes Jahr für aktive Anleihenmanager. <strong>53,5% übertrafen ihre Benchmarks</strong> (1-Jahr), bei EUR Corporate Bonds waren es sogar <strong>78,7%</strong>. Über 10 Jahre erreichten immerhin <strong>23% eine persistente Outperformance</strong>. In Deutschland zeigen Spezialfonds (2009-2022) mit <strong>4,1% p.a. bei 4,3% Volatilität</strong> bessere Ergebnisse als Euro-Staatsanleihen (2,2%).</p>

    <h3>Warum diese Unterschiede?</h3>

    <p>Martijn Cremers (Notre Dame) liefert die Antwort. Seine bahnbrechende Forschung zeigt: <strong>High Active Share plus Geduld (über zwei Jahre Haltedauer) ergibt 2,04% p.a. Outperformance</strong>. Aber High Active Share plus Frequent Trading führt zu minus 1,15% p.a. Underperformance.</p>

    <p>Seine Erklärung: „Successful active managers succeed in identifying temporarily undervalued stocks. But it's very difficult to do that over a short-term horizon, because markets are not efficient over short time periods."</p>

    <p>Small Caps und Anleihen sind weniger effiziente Märkte. Weniger Analysten, langsamere Informationsverarbeitung, höhere Rendite-Dispersion. Genau dort, wo die Effizienzmarkthypothese an ihre Grenzen stößt, haben überzeugte aktive Manager ihre Chance.</p>
  `
};
